import { assertNever } from "../assert-types/assertNever.js";
function flatClassNameList(className) {
  if (!className) {
    return [];
  } else if (typeof className === "string") {
    return className.split(" ").filter(Boolean);
  } else if (Array.isArray(className)) {
    return className.flatMap(flatClassNameList);
  } else {
    assertNever();
  }
}
export {
  flatClassNameList
};
//# sourceMappingURL=flatClassNameList.js.map
